import React, { useEffect, useReducer } from "react"
import styled from "@emotion/styled"
import PriceBox from "./PriceBox.js"
import PriceBoxSpecial from "./PriceBoxSpecial.js"
import FadeIn from "react-lazyload-fadein"
import { ParityPrice } from "bigmac-index-price-calculator"

const parityPrice = new ParityPrice("cb952dd732eb8e511d44d441788fcf67", true)

const Wrapper = styled.div`
  margin: 7rem 0rem;
`
const WrapperBlock = styled.div`
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
  @media (max-width: 940px) {
    font-size: 20px;
  }

  @media (max-width: 940px) {
    display: flex;
    flex-direction: column-reverse;
  }
`

/* eslint-disable react-hooks/exhaustive-deps */
const BigBuyButton = ({ id, price, onload, coupon }) => {
  useEffect(() => onload(), [])

  const url = coupon
    ? `https://gumroad.com/l/${id}/${coupon}`
    : `https://gumroad.com/l/${id}`

  return (
    <a
      href={url}
      className="btn btn-grey btn-min-width"
      data-gumroad-product-id={id}
      data-gumroad-single-product="true"
    >
      Buy now ${price}
    </a>
  )
}
/* eslint-enable react-hooks/exhaustive-deps */

export const FadeInButton = ({ id, price, coupon }) => {
  // let offer = price * context.offer.value,
  //     strike = offer === price ? "" : <strike>${price}</strike>;

  return (
    // <a
    //     href={`https://gumroad.com/l/${id}?wanted=true`}
    //     data-gumroad-single-product="true"
    //     data-gumroad-produc-id={id}
    //     className="btn btn-grey btn-min-width gumroad-product-embed"
    // >
    //     Buy now for ${price}
    // </a>
    <FadeIn height={55} duration={150}>
      {(onload) => (
        <BigBuyButton id={id} coupon={coupon} price={price} onload={onload} />
      )}
    </FadeIn>
  )
}

const priceReducer = (state, action) => {
  switch (action.type) {
    case "loaded":
      return {
        ...action.data,
      }
    default:
      return state
  }
}

const countryList = [
  "Canada",
  "Denmark",
  "Israel",
  "Brazil",
  "Australia",
  "Lebanon",
  "Uruguay",
  "Singapore",
  "New Zealand",
  "Britain",
  "South Korea",
  "Chile",
  "United Arab Emirates",
  "Czech Republic",
  "Costa Rica",
  "Colombia",
  "Thailand",
  "Japan",
  "Honduras",
  "Kuwait",
  "Pakistan",
  "Qatar",
  "Croatia",
  "Guatemala",
  "Saudi Arabia",
  "Bahrain",
  "Nicaragua",
  "Sri Lanka",
  "Peru",
  "China",
  "Hungary",
  "Vietnam",
  "Poland",
  "Jordan",
  "Oman",
  "Philippines",
  "India",
  "Hong Kong",
  "Mexico",
  "Indonesia",
  "Azerbaijan",
  "Moldova",
  "Romania",
  "Taiwan",
  "South Africa",
  "Egypt",
  "Malaysia",
  "Argentina",
  "Turkey",
  "Ukraine",
  "Russia",
].map((s) => s.toLowerCase())

const Pricing = () => {
  const [{ tier1, tier2, location, adjusted }, dispatch] = useReducer(
    priceReducer,
    {
      data: {
        tier1: 59,
        tier2: 179,
        location: {},
        adjusted: false,
      },
    }
  )

  const calcPrices = async () => {
    // parityPrice is internally memoized so this fires only 1 request
    let tier1 = await parityPrice.price(59)
    let tier2 = await parityPrice.price(179)
    let adjusted = true
    const { location } = await parityPrice.priceWithLocation(tier1)

    if (tier1 >= 59) {
      tier1 = 59
      tier2 = 179
      adjusted = false
    }

    dispatch({
      type: "loaded",
      data: {
        location,
        tier1,
        tier2,
        adjusted,
      },
    })
  }

  useEffect(() => {
    calcPrices()
  }, [])

  const country = location && location.country_name
  const coupon =
    country && countryList.includes(country.toLowerCase())
      ? country
      : country && location.continent_code

  return (
    <Wrapper id="pricing">
      <WrapperBlock>
        <PriceBox
          price={
            <>
              <span className="curr">$</span>
              {tier1}
            </>
          }
          plan="Example Tier"
          features={
            <div>
              Extend the Pricing component with your implementation
              <br />
              <br />
              Money-back guarantee
              <br />
              Yours forever
            </div>
          }
          button={
            <FadeInButton
              id="Fqwwi"
              price={tier1}
              coupon={adjusted ? coupon : null}
            />
          }
          location={adjusted ? country : null}
        />
        <PriceBoxSpecial
          price={
            <>
              <span className="curr">$</span>
              {tier2}
            </>
          }
          plan={
            <div>
              <p>
                <strong>Example special Tier</strong>
              </p>
            </div>
          }
          features={
            <div>
              <b>30min 1on1 call where we discuss your usecase</b>
              <br />
              <br />
              Example of the features
              <br />
              More features
              <br />
              <br />
              Money-back guarantee
              <br />
              Yours forever
            </div>
          }
          button={
            <FadeInButton
              id="Hnbtz"
              price={tier2}
              coupon={adjusted ? coupon : null}
            />
          }
          location={adjusted ? country : null}
        />
      </WrapperBlock>
    </Wrapper>
  )
}

export default Pricing
